"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

var _articleAuthors = _interopRequireDefault(require("../components/article-authors"));

var _articleFreeReads = _interopRequireDefault(require("../components/article-free-reads"));

var _articleFreeReadsRedirect = _interopRequireDefault(require("../components/article-free-reads-redirect"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

(function () {
  var selectors = {
    articleContainer: '[role="article"]',
    relatedBooks: '[role="related-books"]',
    relatedProducts: '[role="related-products"]',
    articleTitle: '[role="title"]',
    loadMoreButton: '[js-next-pagination]',
    mainContent: '#MainContent'
  };

  var RelatedBooks =
  /*#__PURE__*/
  function () {
    function RelatedBooks(container) {
      _classCallCheck(this, RelatedBooks);

      this.container = container;
    }

    _createClass(RelatedBooks, [{
      key: "cacheSelectors",
      value: function cacheSelectors() {
        this.cache = {
          $container: document.querySelector(this.container)
        };
        this.strings = {
          freeReadsArticle: 'free-reads-article',
          authorArticle: 'author-article'
        };
        this.nodeSelectors = {
          customerResetPassword: document.querySelector(selectors.promptButton)
        };
      }
    }, {
      key: "relatedProductsInit",
      value: function relatedProductsInit() {
        if (this.cache.$container.classList.contains(this.strings.freeReadsArticle)) {
          (0, _articleFreeReads["default"])().init();
        } else if (this.cache.$container.classList.contains(this.strings.authorArticle)) {
          (0, _articleAuthors["default"])().init();
        }
      }
    }, {
      key: "init",
      value: function init() {
        this.cacheSelectors();
        this.relatedProductsInit();
      }
    }]);

    return RelatedBooks;
  }();

  var articleContainer = selectors.articleContainer;
  var featuredBooks = new RelatedBooks(articleContainer);
  featuredBooks.init();
  (0, _articleFreeReadsRedirect["default"])().init();
})();